function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
// import classnames from 'classnames'
import equals from 'fast-deep-equal';
import { PortalOverlay, Pane, Button, Dialog } from '@leverege/ui-elements';
import OkayCancelEditor from "./OkayCancelEditor.js";
import S from './EditorDialog.css';
export default class EditorDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {},
      currentValue: {}
    };
  }
  static getDerivedStateFromProps(props, state) {
    const {
      value
    } = props;
    if (value !== state.value) {
      return {
        value,
        currentValue: value
      };
    }
    return null;
  }
  onChange = evt => {
    this.setState({
      currentValue: evt.value
    });
  };
  onOkay = () => {
    const {
      onOkay,
      eventData
    } = this.props;
    const {
      currentValue
    } = this.state;
    onOkay({
      value: currentValue,
      data: eventData
    });
  };
  onPortalOkay = event => {
    const {
      onOkay,
      eventData
    } = this.props;
    onOkay({
      value: event.value,
      data: eventData
    });
  };
  render() {
    const {
      dialog = false,
      style = null,
      onClose,
      show,
      editor: Editor,
      title = 'Edit',
      icon,
      editorProps = {},
      validator = null,
      portalId,
      portalShowBackground,
      portalAnimation = 'slideFromTop',
      portalPosition = 'center',
      cancelLabel = 'Cancel',
      okayLabel = 'Okay',
      paneVariant = 'editorDialog',
      dialogContentVariant = 'dialogContent',
      editorVariants
    } = this.props;
    const {
      currentValue,
      value
    } = this.state;
    const isOkay = (typeof validator === 'function' ? validator(currentValue, value) : true) && !equals(value, currentValue);
    const s = paneVariant == null ? {
      background: 'white',
      ...style
    } : style;
    if (!dialog) {
      return /*#__PURE__*/React.createElement(PortalOverlay, {
        show: show,
        showBackground: portalShowBackground,
        targetId: portalId,
        animation: portalAnimation,
        position: portalPosition
      }, /*#__PURE__*/React.createElement(Pane, {
        variant: paneVariant,
        style: s
      }, /*#__PURE__*/React.createElement(OkayCancelEditor, {
        className: S.dialogContrib,
        editor: Editor,
        history: null,
        title: title,
        icon: icon,
        actionState: null,
        applyOnChange: false,
        validator: validator,
        editorProps: editorProps,
        variants: editorVariants,
        value: value || {},
        onCancel: onClose,
        onChange: this.onPortalOkay,
        okayLabel: okayLabel,
        cancelLabel: cancelLabel
      })));
    }

    // Not sure I really need this path.
    const footer = /*#__PURE__*/React.createElement("div", {
      className: S.footer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onClose
    }, cancelLabel), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      disabled: !isOkay,
      onClick: this.onOkay
    }, okayLabel));
    return /*#__PURE__*/React.createElement(Dialog, {
      show: show,
      closeOnDocumentClick: false,
      contentVariant: dialogContentVariant,
      title: title,
      footer: footer,
      onClose: onClose
    }, /*#__PURE__*/React.createElement(Editor, _extends({}, editorProps, {
      value: currentValue,
      onClose: onClose,
      onChange: this.onChange
    })));
  }
}